import {
  Divider,
  GKButton,
  GKDatePicker,
  GKSearchSelect,
  GKSelect,
  GKTextField,
  Grid2,
  MenuItem,
  PhoneInput,
  ReloadIcon,
  Typography,
} from "components";
import dayjs from "dayjs";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import axiosInstance from "utils/axiosInstance";
import { MARITAL_STATUS, PERSONAL_GENDER } from "utils/constants";
import {
  emailRegex,
  panRegex,
  validateNotWhitespaceOnly,
} from "utils/validationSchema";
import InvestorBankDetails from "./InvestorBankDetails";
import { useInvestorContext } from "./InvestorContext";
import NomineeDetails from "./NomineeDetails";
import { useKRADataHandler } from "./useKRADataHandler";

interface Props {
  companyId: string;
  basketId: string;
}

const DetailsTab = (props: Props) => {
  const form = useFormContext();

  const {
    state: { countryList, stateList, cityList },
    dispatch,
  } = useInvestorContext();

  const [hasError, setHasError] = useState(false);
  const [birthCountryStates, setBirthCountryStates] = useState<any[]>([]);

  const { handleGetKRAData, KRALoading } = useKRADataHandler(
    form,
    props.basketId,
  );

  // const { mutate: handleGetKRAData, isLoading: KRALoading } = useMutation({
  //   mutationKey: ["GET_KRA_DATA"],
  //   mutationFn: (dataItem: any) => {
  //     return axiosInstance.post("/pan-details/", dataItem, {
  //       headers: { Authorization: null },
  //     });
  //   },
  //   onSuccess: (response) => {
  //     form.setValue(
  //       "clientCreation.personalDetails.name",
  //       response.data.data.name,
  //     );
  //     form.setValue("fetchedFromKra", true);
  //     form.setValue(
  //       "clientCreation.personalDetails.address",
  //       response.data.data.address,
  //     );
  //     form.setValue(
  //       "clientCreation.personalDetails.gender",
  //       response.data.data.gender,
  //     );
  //     form.setValue(
  //       "clientCreation.personalDetails.pincode",
  //       response.data.data.pincode,
  //     );

  //     if (!isEmpty(response?.data?.data?.country)) {
  //       dispatch({
  //         type: "SELECTED_COUNTRY",
  //         data: countryList.find(
  //           (dataItem) =>
  //             capitalize(dataItem.name) ===
  //             capitalize(response?.data?.data?.country),
  //         )?.id,
  //       });

  //       form.setValue(
  //         "clientCreation.personalDetails.country",
  //         capitalize(response?.data?.data?.country),
  //       );
  //     }
  //     if (!isEmpty(response?.data?.data?.state)) {
  //       dispatch({
  //         type: "SELECTED_STATE",
  //         data: stateList.find(
  //           (dataItem) =>
  //             capitalize(dataItem.name) ===
  //             capitalize(response?.data?.data?.state),
  //         )?.id,
  //       });

  //       form.setValue(
  //         "clientCreation.personalDetails.state",
  //         capitalize(response?.data?.data?.state),
  //       );
  //     }
  //     if (!isEmpty(response?.data?.data?.city)) {
  //       dispatch({
  //         type: "SELECTED_CITY",
  //         data: cityList.find(
  //           (dataItem) =>
  //             capitalize(dataItem.name) ===
  //             capitalize(response?.data?.data?.city),
  //         )?.id,
  //       });

  //       form.setValue(
  //         "clientCreation.personalDetails.city",
  //         capitalize(response?.data?.data?.city),
  //       );
  //     }
  //   },
  // });

  const INCOME_SLAB_OPTIONS = [
    { label: "Upto 1 Lakh", value: "upto_1lakh" },
    { label: "Above 1 Lakh upto 5 Lakh", value: "above_1lakh_upto_5lakh" },
    { label: "Above 5 Lakh upto 10 Lakh", value: "above_5lakh_upto_10lakh" },
    { label: "Above 10 Lakh upto 25 Lakh", value: "above_10lakh_upto_25lakh" },
    { label: "Above 25 Lakh upto 1 Cr", value: "above_25lakh_upto_1cr" },
    { label: "Above 1 Cr", value: "above_1cr" },
  ];

  const OCCUPATION_OPTIONS = [
    { label: "Business", value: "business" },
    { label: "Professional", value: "professional" },
    { label: "Retired", value: "retired" },
    { label: "House Wife", value: "house_wife" },
    { label: "Student", value: "student" },
    { label: "Public Sector Service", value: "public_sector_service" },
    { label: "Private Sector Service", value: "private_sector_service" },
    { label: "Government Service", value: "government_service" },
    { label: "Agriculture", value: "agriculture" },
    { label: "Doctor", value: "doctor" },
    { label: "Service", value: "service" },
    { label: "Others", value: "others" },
  ];

  const SOURCE_OF_WEALTH_OPTIONS = [
    { label: "Salary", value: "salary" },
    { label: "Business", value: "business" },
    { label: "Gift", value: "gift" },
    { label: "Ancestral Property", value: "ancestral_property" },
    { label: "Rental Income", value: "rental_income" },
    { label: "Prize Money", value: "prize_money" },
    { label: "Royalty", value: "royalty" },
    { label: "Others", value: "others" },
  ];

  return (
    <Grid2 container columnSpacing={{ xs: 0, md: 2 }} rowSpacing={3}>
      <Grid2
        size={{ xs: 12, md: 7 }}
        display={"flex"}
        flexDirection={"column"}
        gap={1}
      >
        <Typography fontSize={20} fontWeight={700} color="var(--black-900)">
          Personal Info
        </Typography>
        <Typography fontSize={12} fontWeight={500} color="var(--neutral-500)">
          Lorem ipsum dolor sit amet consectetur. Congue adipiscing odio viverra
          pharetra porttitor tincidunt.
        </Typography>
      </Grid2>
      <Grid2
        size={{ xs: 12, md: 5 }}
        display={"flex"}
        justifyContent={{ xs: "flex-start", md: "flex-end" }}
        alignItems={"start"}
        sx={{ order: { xs: -1, md: 0 } }}
      >
        <img
          src="/Logos/iconFullLogo.png"
          alt="GridKey Logo"
          style={{
            height: "32px",
            width: "auto",
          }}
        />
      </Grid2>
      <Grid2 size={12}>
        <Controller
          name="clientCreation.personalDetails.name"
          control={form.control}
          rules={{
            required: { value: true, message: "Please enter name" },
            validate: validateNotWhitespaceOnly,
          }}
          render={({ field, fieldState: { error } }) => (
            <GKTextField
              {...field}
              inputLabel="Name"
              requiredField
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.pan"
          rules={{
            required: { value: true, message: "Please enter PAN" },
            pattern: {
              value: panRegex,
              message: "PAN should have this format ABCDE1234A",
            },
            maxLength: {
              value: 10,
              message: "PAN should have 10 character",
            },
            minLength: {
              value: 10,
              message: "PAN should have 10 character",
            },
          }}
          control={form.control}
          render={({ field, fieldState: { error } }) => (
            <GKTextField
              {...field}
              inputLabel="PAN"
              onChange={(e) => field.onChange(e.target.value.toUpperCase())}
              requiredField
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.dateOfBirth"
          control={form.control}
          rules={{
            required: { value: true, message: "Please select date of birth" },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKDatePicker
              {...field}
              disableFuture
              requiredField
              inputLabel="Date Of Birth"
              value={dayjs(field.value)}
              onChange={(value) => {
                field.onChange(dayjs(value).format("YYYY-MM-DD"));
              }}
              minDate={dayjs("01-01-1901")}
              slotProps={{
                textField: {
                  error: !!error,
                  helperText: error?.message,
                },
              }}
            />
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.aadhar"
          control={form.control}
          rules={{
            required: { value: true, message: "Please enter Aadhaar number" },
            minLength: {
              value: 12,
              message: "Aadhaar number should have 12 digits",
            },
            maxLength: {
              value: 12,
              message: "Aadhaar number should have 12 digits",
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKTextField
              {...field}
              inputLabel="Aadhaar No."
              requiredField
              placeholder="12 Digit Aadhar Number"
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </Grid2>
      <Grid2
        size={{ xs: 12, md: 6 }}
        display={"flex"}
        flexDirection={"column"}
        alignItems={{ xs: "flex-start", md: "flex-end" }}
      >
        <GKButton
          startIcon={<ReloadIcon />}
          loading={KRALoading}
          onClick={() => {
            handleGetKRAData({
              phone: form.getValues("clientCreation.phone"),
              pan: form.getValues("clientCreation.personalDetails.pan"),
              dob: dayjs(
                form.getValues("clientCreation.personalDetails.dateOfBirth"),
              ).format("YYYY-MM-DD"),
            });
          }}
        >
          Fetch My Details
        </GKButton>
      </Grid2>
      <Grid2 size={12}>
        <Divider />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.phone"
          rules={{
            required: { value: true, message: "Please enter phone number" },
          }}
          control={form.control}
          render={({ field, fieldState: { error } }) => (
            <PhoneInput
              {...field}
              onSelectChange={(event: any) => {
                form.setValue("clientCreation.countryCode", event);
              }}
              onTextChange={(event: any) => {
                field.onChange(event);
              }}
              inputLabel="Phone Number"
              onTextValue={field.value}
              requiredField
              onSelectValue={
                form.getValues("clientCreation.countryCode") || "+91"
              }
              error={!!error || hasError}
              helperText={error?.message}
              hasError={hasError}
              setHasError={setHasError}
            />
          )}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.email"
          control={form.control}
          rules={{
            required: { value: true, message: "Please enter email" },
            pattern: {
              value: emailRegex,
              message: "Please enter a valid mail",
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKTextField
              {...field}
              inputLabel="Email"
              requiredField
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </Grid2>
      <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
        <Typography
          color="var(--neutral-500)"
          fontSize={12}
          whiteSpace={"nowrap"}
          fontWeight={600}
        >
          ADDRESS DETAILS
        </Typography>
        <Divider sx={{ flex: 1 }} />
      </Grid2>
      <Grid2 size={12}>
        <Controller
          name="clientCreation.personalDetails.address"
          control={form.control}
          rules={{ required: { value: true, message: "Please enter address" } }}
          render={({ field, fieldState: { error } }) => (
            <GKTextField
              {...field}
              inputLabel="Address"
              requiredField
              autoComplete="off"
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.country"
          control={form.control}
          rules={{
            required: {
              value: true,
              message: "Please select a country",
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKSearchSelect
              {...field}
              requiredField
              inputLabel="Country"
              error={!!error}
              helperText={error?.message}
              options={countryList || []}
              getOptionLabel={(e) => e.name || e}
              onChange={(e, val) => {
                field.onChange(val.name);
                form.setValue("clientCreation.personalDetails.city", "");
                form.setValue("clientCreation.personalDetails.state", "");
                dispatch({ type: "SELECTED_COUNTRY", data: val.id });
              }}
            />
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.state"
          control={form.control}
          rules={{
            required: {
              value: true,
              message: "Please select a state",
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKSearchSelect
              {...field}
              inputLabel="State"
              requiredField
              error={!!error}
              helperText={error?.message}
              options={stateList || []}
              getOptionLabel={(e) => e.name || e}
              onChange={(e, val) => {
                field.onChange(val.name);
                form.setValue("personalDetails.city", "");
                dispatch({ type: "SELECTED_STATE", data: val.id });
              }}
            />
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.city"
          control={form.control}
          rules={{ required: { value: true, message: "Please select city" } }}
          render={({ field, fieldState: { error } }) => (
            <GKSearchSelect
              {...field}
              requiredField
              inputLabel="City"
              error={!!error}
              helperText={error?.message}
              options={cityList || []}
              getOptionLabel={(e) => e.name || e}
              onChange={(e, val) => {
                field.onChange(val.name);
                dispatch({ type: "SELECTED_CITY", data: val.id });
              }}
            />
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.pincode"
          control={form.control}
          rules={{ required: { value: true, message: "Please enter pincode" } }}
          render={({ field, fieldState: { error } }) => (
            <GKTextField
              {...field}
              inputLabel="Pincode"
              requiredField
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </Grid2>
      <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
        <Typography
          color="var(--neutral-500)"
          fontSize={12}
          whiteSpace={"nowrap"}
          fontWeight={600}
        >
          BANK DETAILS
        </Typography>
        <Divider sx={{ flex: 1 }} />
      </Grid2>
      <Grid2 size={12}>
        <InvestorBankDetails />
      </Grid2>
      <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
        <Typography
          color="var(--neutral-500)"
          fontSize={12}
          whiteSpace={"nowrap"}
          fontWeight={600}
        >
          NOMINEE DETAILS
        </Typography>
        <Divider sx={{ flex: 1 }} />
      </Grid2>
      <Grid2 size={12}>
        <NomineeDetails />
      </Grid2>
      <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
        <Typography
          color="var(--neutral-500)"
          fontSize={12}
          whiteSpace={"nowrap"}
          fontWeight={600}
        >
          PERSONAL INFORMATION
        </Typography>
        <Divider sx={{ flex: 1 }} />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.gender"
          control={form.control}
          rules={{ required: { value: true, message: "Please select gender" } }}
          render={({ field, fieldState: { error } }) => (
            <GKSearchSelect
              {...field}
              requiredField
              disableClearable={false}
              inputLabel="Gender"
              error={!!error}
              helperText={error?.message}
              options={PERSONAL_GENDER || []}
              onChange={(event, val) => {
                field.onChange(val?.value);
              }}
              getOptionLabel={(option) => option.name || option}
            />
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.maritalStatus"
          control={form.control}
          rules={{
            required: { value: true, message: "Please select marital status" },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKSelect
              {...field}
              requiredField
              inputLabel="Marital Status"
              error={!!error}
              helperText={error?.message}
              MenuProps={{ disableScrollLock: true }}
            >
              <MenuItem style={{ display: "none" }} value="">
                Select Marital Status
              </MenuItem>
              {MARITAL_STATUS?.map((data) => (
                <MenuItem value={data.value} key={data.value}>
                  {data.name}
                </MenuItem>
              ))}
            </GKSelect>
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.fatherName"
          control={form.control}
          rules={{
            required: { value: true, message: "Please enter father's name" },
            validate: validateNotWhitespaceOnly,
          }}
          render={({ field, fieldState: { error } }) => (
            <GKTextField
              {...field}
              requiredField
              inputLabel="Father's Name"
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.motherName"
          control={form.control}
          rules={{
            required: { value: true, message: "Please enter mother's name" },
            validate: validateNotWhitespaceOnly,
          }}
          render={({ field, fieldState: { error } }) => (
            <GKTextField
              {...field}
              requiredField
              inputLabel="Mother's Name"
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.country_of_birth"
          control={form.control}
          rules={{
            required: {
              value: true,
              message: "Please select country of birth",
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKSearchSelect
              {...field}
              requiredField
              inputLabel="Country of Birth"
              error={!!error}
              helperText={error?.message}
              options={countryList || []}
              getOptionLabel={(e) => e.name || e}
              onChange={(e, val) => {
                if (!val?.id) return;
                field.onChange(val.name);
                form.setValue(
                  "clientCreation.personalDetails.place_of_birth",
                  "",
                );
                setBirthCountryStates([]);
                axiosInstance
                  .get(`/state/?country_id=${val.id}`)
                  .then((res) => setBirthCountryStates(res.data?.data || []));
              }}
            />
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.place_of_birth"
          control={form.control}
          rules={{
            required: { value: true, message: "Please select place of birth" },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKSearchSelect
              {...field}
              value={
                birthCountryStates.find((s: any) => s.name === field.value) ||
                null
              }
              requiredField
              inputLabel="Place of Birth"
              error={!!error}
              helperText={error?.message}
              options={birthCountryStates}
              getOptionLabel={(e) => (e as any).name || e}
              onChange={(e, val) => {
                field.onChange((val as any)?.name || "");
              }}
            />
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.nationality_country"
          control={form.control}
          rules={{
            required: { value: true, message: "Please select nationality" },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKSearchSelect
              {...field}
              requiredField
              inputLabel="Nationality"
              error={!!error}
              helperText={error?.message}
              options={countryList || []}
              getOptionLabel={(e) => e.name || e}
              onChange={(e, val) => {
                field.onChange(val.name);
              }}
            />
          )}
        />
      </Grid2>
      <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
        <Typography
          color="var(--neutral-500)"
          fontSize={12}
          whiteSpace={"nowrap"}
          fontWeight={600}
        >
          PROFESSIONAL & FINANCIAL
        </Typography>
        <Divider sx={{ flex: 1 }} />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.income"
          control={form.control}
          rules={{
            required: { value: true, message: "Please select income slab" },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKSelect
              {...field}
              value={typeof field.value === "string" ? field.value : ""}
              inputLabel="Income Slab"
              requiredField
              error={!!error}
              helperText={error?.message}
              MenuProps={{ disableScrollLock: true }}
            >
              <MenuItem style={{ display: "none" }} value="">
                Select Income Range
              </MenuItem>
              {INCOME_SLAB_OPTIONS.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </GKSelect>
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.occupation"
          control={form.control}
          rules={{
            required: { value: true, message: "Please select occupation type" },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKSelect
              {...field}
              inputLabel="Occupation Type"
              requiredField
              error={!!error}
              helperText={error?.message}
              MenuProps={{ disableScrollLock: true }}
            >
              <MenuItem style={{ display: "none" }} value="">
                Select Occupation Type
              </MenuItem>
              {OCCUPATION_OPTIONS.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </GKSelect>
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="clientCreation.personalDetails.source_of_wealth"
          control={form.control}
          rules={{
            required: {
              value: true,
              message: "Please select source of wealth",
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKSelect
              {...field}
              inputLabel="Source of Wealth"
              requiredField
              error={!!error}
              helperText={error?.message}
              MenuProps={{ disableScrollLock: true }}
            >
              <MenuItem style={{ display: "none" }} value="">
                Select Source of Wealth
              </MenuItem>
              {SOURCE_OF_WEALTH_OPTIONS.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </GKSelect>
          )}
        />
      </Grid2>
    </Grid2>
  );
};

export default DetailsTab;
